import { Container } from 'react-bootstrap';
import './search-page.scss';
import { Ai2Layout } from '../../layout/Ai2Layout';
import { SearchBox } from './components/searchBox/SearchBox';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { SystemPermission } from '../../../context';
import { useNavigate } from 'react-router-dom';
import useUserPermission from '../../hooks/useUserPermission';
import type { SearchPageContent } from './searchPageConfig';

interface BaseSearchPageProps {
  content: SearchPageContent;
}

const BaseSearchPage = ({ content }: BaseSearchPageProps) => {
  const navigate = useNavigate();
  const { userHasPermissions } = useUserPermission();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const havingSearchFilters = !!selectedTenancy?.features?.searchFiltersMap;

  if (
    selectedTenancy &&
    selectedTenancy?.permissionsSetup &&
    !userHasPermissions(SystemPermission.VIEW_PATIENT_LIST)
  ) {
    navigate('/');
    return null;
  }

  if (!havingSearchFilters) {
    navigate('/');
    return null;
  }

  return (
    <Ai2Layout>
      <div className="ui">
        <Container fluid>
          <div className="flexVert offsetNavbar">
            <div className="search-page-container">
              <div className="search-page-title">
                <h2>{content.title}</h2>
              </div>
              <div className="search-page-description">
                {content.description.map((text) => (
                  <div key={text}>{text}</div>
                ))}
              </div>
              <SearchBox placeholder={content.searchPlaceholder} />
            </div>
          </div>
        </Container>
      </div>
    </Ai2Layout>
  );
};

export default BaseSearchPage;
